import { render, staticRenderFns } from "./QuickNav.vue?vue&type=template&id=ccde78e2&scoped=true&"
import script from "./QuickNav.vue?vue&type=script&lang=ts&"
export * from "./QuickNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccde78e2",
  null
  
)

export default component.exports